<template>
    <!-- 내 프로파일 : s -->
    <div class="section col_w_3">
        <div class="section_wrap">
          <h6 class="--blue70 mb20">{{ $t('my.profile.title') }}</h6>
            <div
                class="row myProfile"
            >
                <KvTable :items="items"/>
            </div>
            <div class="text_right row">
                <a class="btn blue btn_mid pointer no-drag"
                   @click="$modal.show('yes-or-no-modal', {questionType:'save', function: updateManagerInfoToServer})">
                    {{ $t('status.save') }}
                </a>
            </div>
        </div>
    </div>
    <!-- 내 프로파일 : e -->
</template>
<script>
import KvTable from '@/components/Table/kvTable';
import _API from '../../../../../api';
import {mapActions} from "vuex";

export default {
  name: 'MyProfile',
  components: {KvTable},
  data() {
    const item = [
      {
        index: 0,
        keyTitle: this.$t('user.email'),
        keyType: 'DefaultInfoInput',
        parentClass: [''],
        class: '',
        keyRange: [],
        values: null
      },
      {
        index: 1,
        keyTitle: this.$t('patient.info.image'),
        parentClass: ['doctor_img'],
        keyType: 'ImageSelector',
        class: 'doctor',
        keyRange: [],
        values: null,
        deleteBtn: true,
        folderPath: 'manager/profile',
      },
      {
        index: 2,
        keyTitle: this.$t('user.sign'),
        parentClass: ['sign_img'],
        keyType: 'ImageSelector',
        class: 'sign',
        keyRange: [],
        values: null,
        cropperOptions: {aspectRatio: 4, viewMode: 1},
        outputOptions: {maxWidth:12000, maxHeight:3000},
        folderPath: 'manager/eSignature',
      },
      {
        index: 3,
        keyTitle: this.$t('user.name'),
        keyType: 'DefaultInput',
        parentClass: [''],
        class: '',
        keyRange: [],
        values: null,
        maxLength: 50,
      },
      {
        index: 4,
        keyTitle: this.$t('my.profile.specialty'),
        keyType: 'DefaultInput',
        parentClass: [''],
        class: '',
        keyRange: [],
        values: null,
        maxLength: 50,
      },
      {
        index: 5,
        keyTitle: this.$t('my.profile.background'),
        keyType: 'textArea',
        parentClass: ['background'],
        class: '',
        keyRange: [],
        values: null,
        maxLength: 3000,
      },
      {
        index: 6,
        keyTitle: this.$t('lang.language'),
        keyType: 'TaggableMultipleSelect',
        parentClass: [''],
        class: '',
        keyRange: [],
        values: [],
        filterBy: (option, label, search) => {
          return (`${label}${option?.label}${option?.title}${option?.value}`).toLowerCase().includes(search.toLowerCase());
        }
      },
      {
        index: 7,
        keyTitle: this.$t('my.profile.pro_edu'),
        keyType: 'DefaultInput',
        parentClass: [''],
        class: '',
        keyRange: [],
        values: null,
        maxLength: 100,
      },
      {
        index: 8,
        keyTitle: this.$t('my.profile.experience'),
        keyType: 'DefaultInput',
        parentClass: [''],
        class: '',
        keyRange: [],
        values: null,
        maxLength: 100,
      },
    ];
    return {
      items: item,
      managerImageUrl : '',
      managerESignatureImageUrl : '',
      langList: []
    }
  },
  methods: {
    ...mapActions(['changeAuth']),
    getManagerInfoFromServer() {
      return new Promise((resolve, reject) => {
        _API.USER.getManagerInfoFromServer()
            .then(({data}) => {
              if (data.isSuccess === true) {
                this.managerImageUrl = data.manager.managerImageUrl;
                this.managerESignatureImageUrl = data.manager?.managerESignatureImageUrl;

                this.items[0].values = data.manager.managerEmail;
                this.items[1].values = data.manager.managerImageUrl;
                this.items[2].values = data.manager?.managerESignatureImageUrl;
                this.items[3].values = data.manager.managerName;
                this.items[4].values = data.manager.managerSpecialty;
                this.items[5].values = data.manager.managerBackground;
                const langList = data.manager.managerLanguageList.split(',');

                for (let langValue of langList) {
                  for (let thisLangValue of this.langList) {
                    if (langValue === thisLangValue.value)
                      this.items[6].values.push(thisLangValue);
                  }
                }

                this.items[7].values = data.manager.managerProfessionalEducation;
                this.items[8].values = data.manager.managerYearsOfExperience;
                resolve();
              }
              reject();
            })
            .catch(e => {
              console.log(`[getManagerInfoFromServer]`, e);
            });
      });
    },
    updateManagerInfoToServer() {
      if (this.items[0].values !== null) {
        let info = {
          managerName: this.items[3].values,
          managerImageUrl: this.managerImageUrl === this.items[1].values ? undefined : this.items[1].values,
          managerESignatureImageUrl: this.managerESignatureImageUrl === this.items[2].values ? undefined : this.items[2].values,
          managerSpecialty: this.items[4].values,
          managerBackground: this.items[5].values,
          managerLanguageList: this.items[6].values.map(value => {
            return value.value
          }).filter(value => {
            return value !== undefined
          }),
          managerProfessionalEducation: this.items[7].values,
          managerYearsOfExperience: this.items[8].values
        }

        _API.USER.updateManagerInfoToServer(info)
            .then(({data}) => {
              if (data.isSuccess === true) {

                _API.USER.getManagerInfoFromServer()
                    .then(({data}) => {
                      if (data.isSuccess === true)
                        this.managerImageUrl = data.manager.managerImageUrl;
                    })

                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.save_completed'
                });
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.retry_again'
                });
              }
            })
            .catch(e => {
              console.log(`[updateManagerInfoToServer] ${e}`);
            });
      }
    },
    makeLanguageKeyRange() {
      const languages = this.ISO6391.getLanguages(this.ISO6391.getAllCodes());

      for (let languagesValue of languages) {
        let item = {};
        item["label"] = languagesValue.name;
        item["title"] = languagesValue.nativeName;
        item["value"] = languagesValue.code;
        this.langList.push(item);
      }

      this.items[6].keyRange = this.langList;
    }
  },
  mounted() {
    this.makeLanguageKeyRange();
    this.getManagerInfoFromServer();
  }
}
</script>
<style lang="scss">
.myProfile {
  display: flex;
  padding-bottom: 10px;

  .table-container {
    grid-template-columns: repeat(2, 1fr);
    //grid-template-columns: 1fr;
    grid-template-rows: unset;
    width: 600px;

    .item-parent {
      grid-column: 1 / 3;
      flex-direction: column;
      align-items: unset;

      .item-title {
        flex: 2 2 2rem;
      }

      .item-value {
        flex: 1 3 1rem;
      }
    }

    .item-parent:nth-child(2) {
      grid-column: 1 / 2;
    }

    .item-parent:nth-child(3) {
      grid-column: 2 / 3;
    }

    .vs__dropdown-menu {
      max-height: 180px;
    }

    .doctor_img {
      height: 160px;
    }

    .sign_img {
      .item-title {
        flex: 0 2 2rem;
      }

      .pop_image {
        .set_photo_area {
          width: 200px;
          height: 50px;
          border-radius: 0;
        }

        .photo_add_btn {
          bottom: 70px;
          left: 170px;
        }
      }
    }

    .background {
      height: 260px;

      textarea {
        height: 180px;
        width: 551px;
      }
    }
  }
}
</style>